export default __webpack_public_path__ + "javascripts/components/Podcast/SubscriptionOption/stitcher-6f4b164902615cb59bc24db71a15c099.svg";